"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ethers = tslib_1.__importStar(require("ethers"));
const starkwareCrypto = tslib_1.__importStar(require("@authereum/starkware-crypto"));
const PerpetualABI_1 = tslib_1.__importDefault(require("./abi/PerpetualABI"));
class StarkwareController {
    constructor() {
        this._encoder = new ethers.utils.Interface(PerpetualABI_1.default);
    }
    registerUser(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { ethKey, starkKey, operatorSignature } = params;
            return this._encodeFunctionCall('registerUser', [
                ethKey,
                starkKey,
                operatorSignature,
            ]);
        });
    }
    deposit(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType, vaultId, quantizedAmount } = params;
            const args = [starkKey, assetType, vaultId];
            if (typeof quantizedAmount === 'string') {
                args.push(quantizedAmount);
                const fragment = {
                    constant: false,
                    inputs: [
                        {
                            internalType: 'uint256',
                            name: 'starkKey',
                            type: 'uint256',
                        },
                        {
                            internalType: 'uint256',
                            name: 'assetType',
                            type: 'uint256',
                        },
                        {
                            internalType: 'uint256',
                            name: 'vaultId',
                            type: 'uint256',
                        },
                        {
                            internalType: 'uint256',
                            name: 'quantizedAmount',
                            type: 'uint256',
                        },
                    ],
                    name: 'deposit',
                    outputs: [],
                    payable: false,
                    stateMutability: 'nonpayable',
                    type: 'function',
                };
                return this._encodeFunctionCall(fragment, args);
            }
            const fragment = {
                constant: false,
                inputs: [
                    {
                        internalType: 'uint256',
                        name: 'starkKey',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'assetType',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'vaultId',
                        type: 'uint256',
                    },
                ],
                name: 'deposit',
                outputs: [],
                payable: true,
                stateMutability: 'payable',
                type: 'function',
            };
            return this._encodeFunctionCall(fragment, args);
        });
    }
    depositCancel(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetId, vaultId } = params;
            return this._encodeFunctionCall('depositCancel', [
                starkKey,
                assetId,
                vaultId,
            ]);
        });
    }
    depositReclaim(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType, vaultId } = params;
            return this._encodeFunctionCall('depositReclaim', [
                starkKey,
                assetType,
                vaultId,
            ]);
        });
    }
    withdraw(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType } = params;
            return this._encodeFunctionCall('withdraw', [starkKey, assetType]);
        });
    }
    withdrawTo(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType, recipient } = params;
            return this._encodeFunctionCall('withdrawTo', [
                starkKey,
                assetType,
                recipient,
            ]);
        });
    }
    fullWithdrawalRequest(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error('not implemented');
        });
    }
    freezeRequest(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const fragment = {
                constant: false,
                inputs: [
                    {
                        internalType: 'uint256',
                        name: 'starkKey',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'vaultId',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'quantizedAmount',
                        type: 'uint256',
                    },
                ],
                name: 'freezeRequest',
                outputs: [],
                payable: false,
                stateMutability: 'nonpayable',
                type: 'function',
            };
            return this._encodeFunctionCall(fragment, [
                params.starkKey,
                params.vaultId,
                params.quantizedAmount,
            ]);
        });
    }
    freezeRequestTrade(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const fragment = {
                constant: false,
                inputs: [
                    {
                        internalType: 'uint256',
                        name: 'starkKeyA',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'starkKeyB',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'vaultIdA',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'vaultIdB',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'collateralAssetId',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'syntheticAssetId',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountCollateral',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amountSynthetic',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'aIsBuyingSynthetic',
                        type: 'bool',
                    },
                    {
                        internalType: 'uint256',
                        name: 'nonce',
                        type: 'uint256',
                    },
                ],
                name: 'freezeRequest',
                outputs: [],
                payable: false,
                stateMutability: 'nonpayable',
                type: 'function',
            };
            return this._encodeFunctionCall(fragment, [
                starkKeyA,
                starkKeyB,
                vaultIdA,
                vaultIdB,
                collateralAssetId,
                syntheticAssetId,
                amountCollateral,
                amountSynthetic,
                aIsBuyingSynthetic,
                nonce,
            ]);
        });
    }
    escape(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, vaultId, assetId, quantizedAmount } = params;
            return this._encodeFunctionCall('escape', [
                starkKey,
                vaultId,
                assetId,
                quantizedAmount,
            ]);
        });
    }
    depositNft(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, vaultId, assetType, tokenId } = params;
            return this._encodeFunctionCall('depositNft', [
                starkKey,
                assetType,
                vaultId,
                tokenId,
            ]);
        });
    }
    depositNftReclaim(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType, vaultId, tokenId } = params;
            return this._encodeFunctionCall('depositNftReclaim', [
                starkKey,
                assetType,
                vaultId,
                tokenId,
            ]);
        });
    }
    withdrawAndMint(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType, mintingBlob } = params;
            return this._encodeFunctionCall('withdrawAndMint', [
                starkKey,
                assetType,
                mintingBlob,
            ]);
        });
    }
    withdrawNft(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType, tokenId } = params;
            return this._encodeFunctionCall('withdrawNft', [
                starkKey,
                assetType,
                tokenId,
            ]);
        });
    }
    withdrawNftTo(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { starkKey, assetType, tokenId, recipient } = params;
            return this._encodeFunctionCall('withdrawNftTo', [
                starkKey,
                assetType,
                tokenId,
                recipient,
            ]);
        });
    }
    transfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { quantizedAmount, nonce, senderVaultId, assetId, targetVaultId, targetKey, expirationTimestamp, condition, } = params;
            return starkwareCrypto.getTransferMsgHash(quantizedAmount, nonce, senderVaultId, assetId, targetVaultId, targetKey, expirationTimestamp, condition);
        });
    }
    createOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { sellVaultId, buyVaultId, sellQuantizedAmount, buyQuantizedAmount, sellAssetId, buyAssetId, nonce, expirationTimestamp, } = params;
            return starkwareCrypto.getLimitOrderMsgHash(sellVaultId, buyVaultId, sellQuantizedAmount, buyQuantizedAmount, sellAssetId, buyAssetId, nonce, expirationTimestamp);
        });
    }
    configurationHash(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('configurationHash', [input]);
        });
    }
    globalConfigurationHash() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('globalConfigurationHash', []);
        });
    }
    depositCancelDelay() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('DEPOSIT_CANCEL_DELAY', []);
        });
    }
    freezeGracePeriod() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('FREEZE_GRACE_PERIOD', []);
        });
    }
    mainGovernanceInfoTag() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('MAIN_GOVERNANCE_INFO_TAG', []);
        });
    }
    maxVerifierCount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('MAX_VERIFIER_COUNT', []);
        });
    }
    unfreezeDelay() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('UNFREEZE_DELAY', []);
        });
    }
    verifierRemovalDelay() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('VERIFIER_REMOVAL_DELAY', []);
        });
    }
    announceAvailabilityVerifierRemovalIntent(verifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('announceAvailabilityVerifierRemovalIntent', [verifier]);
        });
    }
    announceVerifierRemovalIntent(verifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('announceVerifierRemovalIntent', [verifier]);
        });
    }
    getRegisteredAvailabilityVerifiers() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getRegisteredAvailabilityVerifiers', []);
        });
    }
    getRegisteredVerifiers() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getRegisteredVerifiers', []);
        });
    }
    isAvailabilityVerifier(verifierAddress) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('isAvailabilityVerifier', [verifierAddress]);
        });
    }
    isFrozen() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('isFrozen', []);
        });
    }
    isVerifier(verifierAddress) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('isVerifier', [verifierAddress]);
        });
    }
    mainAcceptGovernance() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('mainAcceptGovernance', []);
        });
    }
    mainCancelNomination() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('mainCancelNomination', []);
        });
    }
    mainIsGovernor(testGovernor) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('mainIsGovernor', [testGovernor]);
        });
    }
    mainNominateNewGovernor(newGovernor) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('mainNominateNewGovernor', [newGovernor]);
        });
    }
    mainRemoveGovernor(governorForRemoval) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('mainRemoveGovernor', [governorForRemoval]);
        });
    }
    registerAvailabilityVerifier(verifier, identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('registerAvailabilityVerifier', [
                verifier,
                identifier,
            ]);
        });
    }
    registerVerifier(verifier, identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('registerVerifier', [verifier, identifier]);
        });
    }
    removeAvailabilityVerifier(verifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('removeAvailabilityVerifier', [verifier]);
        });
    }
    removeVerifier(verifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('removeVerifier', [verifier]);
        });
    }
    unFreeze() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('unFreeze', []);
        });
    }
    getAssetInfo(assetType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getAssetInfo', [assetType]);
        });
    }
    getCancellationRequest(starkKey, assetId, vaultId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getCancellationRequest', [
                starkKey,
                assetId,
                vaultId,
            ]);
        });
    }
    getDepositBalance(starkKey, assetId, vaultId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getDepositBalance', [
                starkKey,
                assetId,
                vaultId,
            ]);
        });
    }
    getEthKey(starkKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getEthKey', [starkKey]);
        });
    }
    getFullWithdrawalRequest(starkKey, vaultId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getFullWithdrawalRequest', [
                starkKey,
                vaultId,
            ]);
        });
    }
    getQuantizedDepositBalance(starkKey, assetId, vaultId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getQuantizedDepositBalance', [
                starkKey,
                assetId,
                vaultId,
            ]);
        });
    }
    getQuantum(presumedAssetType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getQuantum', [presumedAssetType]);
        });
    }
    getSystemAssetType() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getSystemAssetType', []);
        });
    }
    getWithdrawalBalance(starkKey, assetId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getWithdrawalBalance', [starkKey, assetId]);
        });
    }
    isTokenAdmin(testedAdmin) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('isTokenAdmin', [testedAdmin]);
        });
    }
    isUserAdmin(testedAdmin) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('isUserAdmin', [testedAdmin]);
        });
    }
    registerSystemAssetType(assetType, assetInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('registerSystemAssetType', [
                assetType,
                assetInfo,
            ]);
        });
    }
    registerToken(a, b, c) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (c) {
                const fragment = {
                    constant: false,
                    inputs: [
                        {
                            internalType: 'uint256',
                            name: '',
                            type: 'uint256',
                        },
                        {
                            internalType: 'bytes',
                            name: '',
                            type: 'bytes',
                        },
                        {
                            internalType: 'uint256',
                            name: '',
                            type: 'uint256',
                        },
                    ],
                    name: 'registerToken',
                    outputs: [],
                    payable: false,
                    stateMutability: 'nonpayable',
                    type: 'function',
                };
                return this._encodeFunctionCall(fragment, [a, b, c]);
            }
            else {
                const fragment = {
                    constant: false,
                    inputs: [
                        {
                            internalType: 'uint256',
                            name: '',
                            type: 'uint256',
                        },
                        {
                            internalType: 'bytes',
                            name: '',
                            type: 'bytes',
                        },
                    ],
                    name: 'registerToken',
                    outputs: [],
                    payable: false,
                    stateMutability: 'nonpayable',
                    type: 'function',
                };
                return this._encodeFunctionCall(fragment, [a, b]);
            }
        });
    }
    registerTokenAdmin(newAdmin) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('registerTokenAdmin', [newAdmin]);
        });
    }
    registerUserAdmin(newAdmin) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('registerUserAdmin', [newAdmin]);
        });
    }
    unregisterTokenAdmin(oldAdmin) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('unregisterTokenAdmin', [oldAdmin]);
        });
    }
    unregisterUserAdmin(oldAdmin) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('unregisterUserAdmin', [oldAdmin]);
        });
    }
    getLastBatchId() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getLastBatchId', []);
        });
    }
    getOrderRoot() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getOrderRoot', []);
        });
    }
    getOrderTreeHeight() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getOrderTreeHeight', []);
        });
    }
    getSequenceNumber() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getSequenceNumber', []);
        });
    }
    getVaultRoot() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getVaultRoot', []);
        });
    }
    getVaultTreeHeight() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getVaultTreeHeight', []);
        });
    }
    isOperator(testedOperator) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('isOperator', [testedOperator]);
        });
    }
    registerOperator(newOperator) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('registerOperator', [newOperator]);
        });
    }
    setAssetConfiguration(assetId, configHash) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('setAssetConfiguration', [
                assetId,
                configHash,
            ]);
        });
    }
    setGlobalConfiguration(configHash) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('setGlobalConfiguration', [configHash]);
        });
    }
    unregisterOperator(removedOperator) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('unregisterOperator', [removedOperator]);
        });
    }
    updateState(publicInput, applicationData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('updateState', [
                publicInput,
                applicationData,
            ]);
        });
    }
    forcedTradeRequest(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce, signature) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('forcedTradeRequest', [
                starkKeyA,
                starkKeyB,
                vaultIdA,
                vaultIdB,
                collateralAssetId,
                syntheticAssetId,
                amountCollateral,
                amountSynthetic,
                aIsBuyingSynthetic,
                nonce,
                signature,
            ]);
        });
    }
    forcedWithdrawalRequest(starkKey, vaultId, quantizedAmount) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('forcedWithdrawalRequest', [
                starkKey,
                vaultId,
                quantizedAmount,
            ]);
        });
    }
    getForcedTradeRequest(starkKeyA, starkKeyB, vaultIdA, vaultIdB, collateralAssetId, syntheticAssetId, amountCollateral, amountSynthetic, aIsBuyingSynthetic, nonce) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getForcedTradeRequest', [
                starkKeyA,
                starkKeyB,
                vaultIdA,
                vaultIdB,
                collateralAssetId,
                syntheticAssetId,
                amountCollateral,
                amountSynthetic,
                aIsBuyingSynthetic,
                nonce,
            ]);
        });
    }
    getForcedWithdrawalRequest(starkKey, vaultId, quantizedAmount) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._encodeFunctionCall('getForcedWithdrawalRequest', [
                starkKey,
                vaultId,
                quantizedAmount,
            ]);
        });
    }
    perpetualTransfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (params.condition) {
                return starkwareCrypto.getPerpetualConditionalTransferMsgHash(params.assetId, params.assetIdFee, params.receiverPublicKey, params.condition, params.senderPositionId, params.receiverPositionId, params.feePositionId, params.nonce, params.amount, params.maxAmountFee, params.expirationTimestamp);
            }
            else {
                return starkwareCrypto.getPerpetualTransferMsgHash(params.assetId, params.assetIdFee, params.receiverPublicKey, params.senderPositionId, params.receiverPositionId, params.feePositionId, params.nonce, params.amount, params.maxAmountFee, params.expirationTimestamp);
            }
        });
    }
    perpetualLimitOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return starkwareCrypto.getPerpetualLimitOrderMsgHash(params.assetIdSynthetic, params.assetIdCollateral, params.isBuyingSynthetic, params.assetIdFee, params.amountSynthetic, params.amountCollateral, params.amountFee, params.nonce, params.positionId, params.expirationTimestamp);
        });
    }
    perpetualWithdrawal(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return starkwareCrypto.getPerpetualWithdrawalMsgHash(params.assetIdCollateral, params.positionId, params.nonce, params.expirationTimestamp, params.amount);
        });
    }
    parseReturnData(fn, data) {
        let fnName = '';
        if (typeof fn === 'string') {
            fnName = fn;
        }
        else if (fn.name) {
            fnName = fn.name;
        }
        if (this[fnName]) {
            return this._decodeFunctionResult(fnName, data);
        }
        throw new Error('not implemented');
    }
    _encodeFunctionCall(method, args) {
        let fragment;
        if (typeof method === 'string') {
            fragment = method;
        }
        else {
            fragment = ethers.utils.FunctionFragment.from(method);
        }
        return this._encoder.encodeFunctionData(fragment, args);
    }
    _decodeFunctionResult(method, data) {
        const decoded = this._encoder.decodeFunctionResult(method, data);
        if (Array.isArray(decoded) && decoded.length === 1) {
            return decoded[0];
        }
        return decoded;
    }
}
exports.StarkwareController = StarkwareController;
exports.default = StarkwareController;
//# sourceMappingURL=controller.js.map